export default "__VITE_ASSET__DWl8gLXD__"